import axios from "axios";
import { getAuthToken, clearActiveAuth } from "../utils/authStorage";

const api = axios.create({
  baseURL:
    "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net",
});

api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearActiveAuth();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
